import { UI } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

export interface InputClearIconProps {
  onPress: () => void;
}

export const InputClearIcon: React.FC<InputClearIconProps> = ({ onPress }) => {
  return (
    <Pressable onPressIn={onPress} pr={2}>
      <UI.Icon
        testID="input-clear-icon"
        name="Close"
        size="xxs"
        variant="rounded"
        color={Color['brand.primary.principal']}
        backgroundColor={Color['neutral.light']}
      />
    </Pressable>
  );
};
